import Image from '@/components/atoms/image/image';
import RichText from '@/components/atoms/rich-text/rich-text';
import Typography from '@/components/atoms/typography/typography';
import CtaLinkList from '@/components/organisms/cta-link-list/cta-link-list';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import styles from './destination-introduction.module.scss';

export interface DestinationIntroductionProps extends ModuleWrapperProps {
  /** The rich text to show as a description */
  description?: Content.Components['DestinationIntroductionModuleDto']['description'];
  /** The text to show as a headline */
  headline?: Content.Components['DestinationIntroductionModuleDto']['headline'];
  /** The image to show */
  image?: Content.Components['DestinationIntroductionModuleDto']['image'];
  /** The link to show */
  link?: Content.Components['DestinationIntroductionModuleDto']['link'];
}

const DestinationIntroduction = ({
  description,
  headline,
  image,
  link,
  ...rest
}: DestinationIntroductionProps) => {
  return (
    <ModuleWrapper {...rest} className={styles.component}>
      <Container>
        <Row className={styles.row}>
          {image && image.url && (
            <Column offset={{ laptop: 1 }} width={{ laptop: 5 }}>
              <div className={styles.imageWrapper}>
                <Image
                  alt={image.altText}
                  aspectRatio="fourByThree"
                  className={styles.image}
                  src={image.url}
                  srcSet={{
                    desktop: {
                      width: 515,
                    },
                    laptop: {
                      width: 355,
                    },
                    tablet: {
                      width: 672,
                    },
                  }}
                  unoptimized
                  width={311}
                />
              </div>
            </Column>
          )}

          <Column width={{ laptop: 4 }}>
            <div className={styles.contentWrapper}>
              {headline && (
                <div className={styles.headlineWrapper}>
                  <Typography
                    className={styles.headline}
                    tag="h2"
                    tagStyle="displayMedium"
                  >
                    {headline}
                  </Typography>
                </div>
              )}

              {description && <RichText text={description} />}

              {link && (
                <CtaLinkList
                  items={[
                    {
                      $type: 'ButtonLinkCtaDto',
                      link,
                      settings: { variant: 'primary' },
                    },
                  ]}
                />
              )}
            </div>
          </Column>
        </Row>
      </Container>
    </ModuleWrapper>
  );
};

DestinationIntroduction.displayName = 'DestinationIntroduction';

export default DestinationIntroduction;
